import { ApiGetRequest } from '../api';

export const state = {
  data: {
    items: [],
  },
};

export const mutations = {
  changeBank(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getBankByCompany({ commit }, payload = null) {
    commit('changeBank', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/bank-account/company`, payload);
    commit('changeBank', {
      items: !result.error ? result.data.object : [],
    });

    return !result.error ? true : false;
  },
};
